import exportWithNotification, {ExportWithNotificationInput} from 'exports/exportWithNotification';

import * as AnalyticsWarehouseDAO from './AnalyticsWarehouseDAO';

// 2 empty spaces to force a newline:
// https://markdown-guide.readthedocs.io/en/latest/basics.html#line-return
const MARKDOWN_NEWLINE = '  \n';

export function exportUntrustedSQLQueryOutputToCSV(data: AnalyticsWarehouseDAO.ExportQueryData): void {
  exportWithNotification(async () => {
    const {url, warnings} = await AnalyticsWarehouseDAO.exportUntrustedSQLQueryOutputToCSV(data);
    const options: ExportWithNotificationInput = {url};
    if (warnings.length) {
      options.notificationOptions = {duration: 0};
      options.message = `${warnings.join(MARKDOWN_NEWLINE)}${MARKDOWN_NEWLINE}Downloading...`;
    }
    return options;
  });
}
